import { datadogRum } from "@datadog/browser-rum";
import { useAtomValue, useSetAtom } from "jotai";
import { useEffect } from "react";
import { useQuery } from "react-query";
import { useNavigate } from "react-router-dom";

import { getClientConfig } from "api/getClientConfig";
import { sessionClientConfigAtom } from "atoms/clientConfig";

import { AppRoute } from "..";
import { clientIdAtom } from "../../atoms/clientId";

export const useInitialiseConfigFromClientId = () => {
  const navigate = useNavigate();

  const clientId = useAtomValue(clientIdAtom);
  const setClientConfig = useSetAtom(sessionClientConfigAtom(clientId));

  const { error } = useQuery("clientConfig", () => getClientConfig(clientId), {
    enabled: navigator.onLine, // If offline, we use the stored config in atom
    suspense: true,
    useErrorBoundary: false,
    onSuccess: (data) => {
      setClientConfig(data);
    },
    onError: (error) => {
      datadogRum.addError(error, {
        message: `Failed to get config for client ${clientId}`,
      });
    },
  });

  useEffect(() => {
    if (error) {
      datadogRum.addError(error, {
        message: `Failed to fetch client config for clientId: ${clientId}`,
      });
      navigate(AppRoute.ApiError);
    }
  }, [clientId, error, navigate]);
};
